var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"converted-badge",class:{ converted: _vm.value == 1, contact: _vm.value != 1 && _vm.status === 'in_contact' }},[_vm._v(_vm._s(_vm.value == 1 ? 'Converted' : _vm.status === 'in_contact' ? 'In Contact' : 'Not Converted'))])
}
var staticRenderFns = []

export { render, staticRenderFns }